// Copyright (c) 2017 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleNoSapAccess} from '../../../shared/services/error-handlers';

const basePath = '/api';

export const getSecurity = async racfId => {

    const endPoint = `${basePath}/users/${racfId}/security`;
    const options = {
        endpointId: 'security'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        // if this service returns an error it will redirect the user to the NO_SAP_ACCESS error page

        return handleNoSapAccess(response, racfId, 'SECURITY');

    }

};



// WEBPACK FOOTER //
// ./src/user/shared/repositories/security.js